var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStethoscopeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_4690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3258 12.8395V16.15C21.3258 20.1561 18.0872 23.3944 14.0811 23.3944C10.075 23.3944 6.81273 20.1561 6.81273 16.15V15.0225C3.26241 14.5187 0.599609 11.4482 0.599609 7.84987V1.63675C0.599609 1.06123 1.05561 0.605469 1.63113 0.605469H4.74969C5.32545 0.605469 5.78121 1.06123 5.78121 1.63675C5.78121 2.21227 5.32521 2.66827 4.74969 2.66827H2.68665V7.84987C2.68665 10.7047 5.01345 13.0315 7.86825 13.0315C10.723 13.0315 13.0498 10.7047 13.0498 7.84987V2.66827H10.9866C10.411 2.66827 9.95529 2.21251 9.95529 1.63675C9.95529 1.06099 10.411 0.605469 10.9866 0.605469H14.1051C14.6331 0.605469 15.1126 1.06123 15.1126 1.63675V7.84987C15.1126 11.4482 12.4501 14.4947 8.89977 15.0225V16.15C8.89977 19.0046 11.2266 21.3316 14.0814 21.3316C16.9362 21.3316 19.263 19.0046 19.263 16.15V12.8395C17.6554 12.2637 16.7919 10.4887 17.3677 8.88139C17.9434 7.27411 19.7185 6.41059 21.3258 6.98635C22.933 7.56211 23.7966 9.33715 23.2208 10.9444C22.9088 11.8319 22.1893 12.5277 21.3258 12.8395Z",
    fill: "#0052FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_4690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscopeIcon);
export default __webpack_public_path__ + "static/media/StethoscopeIcon.7dd81bfa337f00fd3842ecc55000b26a.svg";
export { ForwardRef as ReactComponent };